module.exports = __webpack_public_path__ + "img/skinAndCo2.66845122.jpg";